import { AnimatedEdge } from './animated';
import { TemporaryEdge } from './temporary';

export const edgeTypes = {
  animated: AnimatedEdge,
  temporary: TemporaryEdge,
};
